/* Singularity Blend: Hotjar custom events (filter recordings/heatmaps by behaviour). Listen-only: never changes the page.
   API: hj('event', name). Events are queued until window.hj exists; most fire once per page load. */
(function () {
  'use strict';
  if (window.refyHj) return;
  var W = window, D = document;
  var pending = [], sent = {}, timer = null, tries = 0;

  function flush() {
    if (typeof W.hj !== 'function') return false;
    while (pending.length) { var n = pending.shift(); try { W.hj('event', n); } catch (e) {} }
    return true;
  }
  function send(name) {
    pending.push(name);
    if (flush() || timer) return;
    timer = setInterval(function () { if (flush() || ++tries > 90) { clearInterval(timer); timer = null; } }, 1000);
  }
  /* once per page load (key defaults to the event name) */
  function once(name, key) { var k = key || name; if (sent[k]) return; sent[k] = 1; send(name); }
  W.refyHj = { send: send, once: once };

  function closest(t, sel) { return t && t.closest ? t.closest(sel) : null; }
  function meta() { return (W.ShopifyAnalytics && W.ShopifyAnalytics.meta) || {}; }
  function mainInfo() { return D.querySelector('product-info[id^="MainProduct-"]'); }
  function isProductPage() { var m = meta(); return (m.page && m.page.pageType === 'product') || !!mainInfo(); }

  /* ---- Product page views ---- */
  function checkBundle() {
    if (!isProductPage()) return;
    var type = ((meta().product || {}).type || '').toLowerCase();
    if (type === 'bundle' || type === 'makeup set' || D.querySelector('fieldset.refy-swatches--dd, [data-refy-shade-images]')) once('view_bundle');
  }
  function selectedVariant(root) {
    var s = root && root.querySelector('variant-selects [data-selected-variant]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function checkSoldOut(v) { if (v && v.available === false) once('sold_out_view', 'sold_out_view:' + v.id); }
  function initProduct() {
    if (!isProductPage()) return;
    once('view_product');
    checkBundle();
    checkSoldOut(selectedVariant(mainInfo()));
    W.addEventListener('load', function () { checkBundle(); setTimeout(checkBundle, 2000); });
  }
  /* Dawn pubsub (constants.js / pubsub.js load before this file; PUB_SUB_EVENTS is a global const, not a window property) */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) { checkSoldOut(ev && ev.data && ev.data.variant); });
    }
  } catch (e) {}

  /* ---- Add to bag / free gift: watch successful /cart/add responses ---- */
  function isGift(body) {
    try {
      if (typeof body === 'string') return body.indexOf('"_gift"') > -1 || body.indexOf('properties%5B_gift%5D') > -1;
      if (body && typeof body.get === 'function') return body.get('properties[_gift]') != null;
    } catch (e) {}
    return false;
  }
  var nativeFetch = W.fetch;
  if (typeof nativeFetch === 'function' && !nativeFetch.refyHj) {
    var wrapped = function (input, init) {
      var p = nativeFetch.apply(W, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
        if (/\/cart\/add(\.js)?$/.test(url.split('#')[0].split('?')[0])) {
          var gift = isGift(init && init.body);
          p.then(function (r) { if (r && r.ok) send(gift ? 'free_bag_added' : 'add_to_cart'); }, function () {});
        }
      } catch (e) {}
      return p;
    };
    wrapped.refyHj = 1;
    W.fetch = wrapped;
  }

  /* ---- Cart drawer opened (must stay open briefly: the gift sync can open/close it in one tick) ---- */
  function watchDrawer() {
    var dr = D.querySelector('cart-drawer'); if (!dr || dr.dataset.refyHj) return;
    dr.dataset.refyHj = '1';
    var was = dr.classList.contains('active');
    new MutationObserver(function () {
      var now = dr.classList.contains('active');
      if (now && !was) setTimeout(function () { if (dr.classList.contains('active')) send('cart_open'); }, 400);
      was = now;
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- Bundle "Add to bag" pressed before every shade is picked (refy.js shows "Please select a shade for X") ---- */
  function missingShade(pi) {
    var dds = pi ? pi.querySelectorAll('.refy-dd') : [];
    for (var i = 0; i < dds.length; i++) if (!dds[i].querySelector('.refy-dd__item[aria-selected="true"]')) return true;
    return false;
  }
  function watchBlocked(e) {
    var t = e.target, form = null;
    if (e.type === 'submit') { if (!/\/cart\/add/.test((t.getAttribute && t.getAttribute('action')) || '')) return; form = t; }
    else { if (!closest(t, '.shopify-payment-button')) return; form = closest(t, 'form') || closest(t, 'product-form'); }
    var pi = closest(form, 'product-info'); if (!pi || !missingShade(pi)) return;
    setTimeout(function () { if (e.defaultPrevented && pi.querySelector('.refy-dd.is-error')) once('bundle_add_blocked'); }, 0);
  }
  W.addEventListener('submit', watchBlocked, true);

  /* ---- Tabs (REFY tabbed content). Label first (en/fr/it/ar), else the block position in the template ---- */
  var TAB_ORDER = ['how_to_use', 'ingredients', 'results', 'faq'];
  function tabKey(tab) {
    var l = (tab.textContent || '').trim().toLowerCase();
    if (/ingr[eé]d|مكون|مكوّن/.test(l)) return 'ingredients';
    if (/faq|question|domand|أسئلة|الأسئلة/.test(l)) return 'faq';
    if (/r[eé]sult|risultat|نتائج|النتائج/.test(l)) return 'results';
    if (/how|use|utilis|utilizz|usare|applica|استخدام|طريقة/.test(l)) return 'how_to_use';
    var m = /-(\d+)$/.exec(tab.id || '');
    return m ? TAB_ORDER[+m[1] - 1] : null;
  }

  /* ---- One capture listener for clicks ---- */
  W.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    watchBlocked(e);
    if (closest(t, '.refy-dd__item')) once('bundle_shade_picked');
    var tab = closest(t, '.refy-section--tabs [role="tab"]');
    if (tab) { var k = tabKey(tab); if (k) once(k + '_open'); }
    if (closest(t, '[name="checkout"], #CartDrawer-Checkout, a[href*="/checkout"], .cart__dynamic-checkout-buttons, .additional-checkout-buttons')) once('checkout_click');
    if (closest(t, 'a[href*="wa.me/"], a[href*="whatsapp.com/"], a[href^="whatsapp:"]')) once('whatsapp_click');
    if (closest(t, '[id*="bundles_row"]') && closest(t, '.card-wrapper, .card, a[href*="/products/"]')) once('size_bundle_row_click');
    if (closest(t, '[data-refy-cur-pick]')) once('currency_change');
    var lang = closest(t, 'localization-form a[data-value]');
    if (lang) { var f = closest(lang, 'form'); if (f && f.querySelector('input[name="locale_code"], input[name="language_code"]')) once('language_change'); }
  }, true);

  /* ---- Changes: swatches, currency / language selects ---- */
  W.addEventListener('change', function (e) {
    var t = e.target; if (!t) return;
    if (closest(t, 'variant-selects') && !closest(t, 'fieldset.refy-swatches--dd')) once('select_shade');
    if (t.hasAttribute && t.hasAttribute('data-refy-cur-select')) once('currency_change');
    if (t.name === 'locale_code' || t.name === 'language_code') once('language_change');
  }, true);

  /* ---- Search: form submitted, search modal opened or search box focused ---- */
  W.addEventListener('submit', function (e) { var a = (e.target && e.target.getAttribute && e.target.getAttribute('action')) || ''; if (/\/search(\?|$)/.test(a)) once('search_used'); }, true);
  W.addEventListener('focusin', function (e) { var t = e.target; if (t && t.matches && t.matches('input[type="search"], predictive-search input, input[name="q"]')) once('search_used'); }, true);
  D.addEventListener('toggle', function (e) { var t = e.target; if (t && t.open && t.closest && t.closest('details-modal.header__search, .header__search')) once('search_used'); }, true);

  /* ---- Comparison table swiped sideways on mobile ---- */
  D.addEventListener('scroll', function (e) {
    var t = e.target; if (!t || !t.classList || !t.classList.contains('refy-compare')) return;
    if (t.scrollLeft !== 0 && W.matchMedia('(max-width: 989px)').matches) once('compare_table_swipe');
  }, { capture: true, passive: true });

  function init() { initProduct(); watchDrawer(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
